import questionIcon from '@source/pages/Home/assets/icons/question.png';
import percentIcon from '@source/pages/Home/assets/icons/percentage.png';
import blogIcon from '@source/pages/Home/assets/icons/blog.png';
import aboutIcon from '@source/pages/Home/assets/icons/about.png';
import locationIcon from '@source/pages/Home/assets/icons/location.png';
import { ENV_URL } from '@source/constants/common';
import { URL_CONFIG } from '@source/constants/urlConfig';
import staticImgs from '@source/constants/staticImg';
import { MenuItem, TLanguageKey, TRegionKey } from '@source/interface';
import { getStaticCDN } from '@design-system/utils/utils';
import { NEXT_PUBLIC_DEALER_PORTAL_URL_MY, NEXT_PUBLIC_WEB_CR } from '@source/constants/env';
import BuyDropDownMenu from './BuyDropDownMenu';

export const BUY_DROPDOWN_MENU = {
  SG: [
    {
      titleTranslate: 'shared.topNavigation.browseCar',
      key: 'browseCar',
      isFontSmall: true,
    },
    {
      title: 'Toyota',
      key: 'Toyota',
      icon: getStaticCDN('/my/img/menu-icons/toyota.png'),
      url: `${ENV_URL.sg}/cars/toyota`,
      isFontSmall: true,
    },
    {
      title: 'Honda',
      key: 'Honda',
      icon: getStaticCDN('/my/img/menu-icons/honda.png'),
      url: `${ENV_URL.sg}/cars/honda`,
      isFontSmall: true,
    },
    {
      title: 'Mercedes-Benz',
      key: 'Mercedes-Benz',
      icon: getStaticCDN('/my/img/menu-icons/mercedes-benz.png'),
      url: `${ENV_URL.sg}/cars/mercedes-benz`,
      isFontSmall: true,
    },
    {
      title: 'Mazda',
      key: 'Mazda',
      icon: getStaticCDN('/my/img/menu-icons/mazda.png'),
      url: `${ENV_URL.sg}/cars/mazda`,
      isFontSmall: true,
    },
    {
      title: 'Mitsubishi',
      key: 'Mitsubishi',
      icon: getStaticCDN('/my/img/menu-icons/mitsubishi.png'),
      url: `${ENV_URL.sg}/cars/mitsubishi`,
      isFontSmall: true,
    },
    {
      title: 'BMW',
      key: 'BMW',
      icon: getStaticCDN('/my/img/menu-icons/bmw.png'),
      url: `${ENV_URL.sg}/cars/bmw`,
      isFontSmall: true,
    },
    {
      title: 'Hyundai',
      key: 'Hyundai',
      icon: getStaticCDN('/static/img/searchBrandIcon/hyundai-color-icon.svg'),
      url: `${ENV_URL.sg}/cars/hyundai`,
      isFontSmall: true,
    },
  ],
  MY: [
    {
      titleTranslate: 'shared.topNavigation.browseCar',
      key: 'browseCar',
      isFontSmall: true,
    },
    {
      title: 'Toyota',
      key: 'Toyota',
      icon: getStaticCDN('/my/img/menu-icons/toyota.png'),
      url: `${ENV_URL.my}/cars/toyota`,
      isFontSmall: true,
    },
    {
      title: 'Honda',
      key: 'Honda',
      icon: getStaticCDN('/my/img/menu-icons/honda.png'),
      url: `${ENV_URL.my}/cars/honda`,
      isFontSmall: true,
    },
    {
      title: 'Mercedes-Benz',
      key: 'Mercedes-Benz',
      icon: getStaticCDN('/my/img/menu-icons/mercedes-benz.png'),
      url: `${ENV_URL.my}/cars/mercedes-benz`,
      isFontSmall: true,
    },
    {
      title: 'Mazda',
      key: 'Mazda',
      icon: getStaticCDN('/my/img/menu-icons/mazda.png'),
      url: `${ENV_URL.my}/cars/mazda`,
      isFontSmall: true,
    },
    {
      title: 'Mitsubishi',
      key: 'Mitsubishi',
      icon: getStaticCDN('/my/img/menu-icons/mitsubishi.png'),
      url: `${ENV_URL.my}/cars/mitsubishi`,
      isFontSmall: true,
    },
    {
      title: 'BMW',
      key: 'BMW',
      icon: getStaticCDN('/my/img/menu-icons/bmw.png'),
      url: `${ENV_URL.my}/cars/bmw`,
      isFontSmall: true,
    },
    {
      title: 'Hyundai',
      key: 'Hyundai',
      icon: getStaticCDN('/static/img/searchBrandIcon/hyundai-color-icon.svg'),
      url: `${ENV_URL.my}/cars/hyundai`,
      isFontSmall: true,
    },
  ],
  TH: [
    {
      titleTranslate: 'shared.topNavigation.browseCar',
      key: 'browseCar',
      isFontSmall: true,
    },
    {
      title: 'Toyota',
      key: 'Toyota',
      icon: getStaticCDN('/my/img/menu-icons/toyota.png'),
      url: `${ENV_URL.th}/taladrod/toyota`,
      isFontSmall: true,
    },
    {
      title: 'Honda',
      key: 'Honda',
      icon: getStaticCDN('/my/img/menu-icons/honda.png'),
      url: `${ENV_URL.th}/taladrod/honda`,
      isFontSmall: true,
    },
    {
      title: 'Mercedes-Benz',
      key: 'Mercedes-Benz',
      icon: getStaticCDN('/my/img/menu-icons/mercedes-benz.png'),
      url: `${ENV_URL.th}/taladrod/mercedes-benz`,
      isFontSmall: true,
    },
    {
      title: 'Mazda',
      key: 'Mazda',
      icon: getStaticCDN('/my/img/menu-icons/mazda.png'),
      url: `${ENV_URL.th}/taladrod/mazda`,
      isFontSmall: true,
    },
    {
      title: 'Mitsubishi',
      key: 'Mitsubishi',
      icon: getStaticCDN('/my/img/menu-icons/mitsubishi.png'),
      url: `${ENV_URL.th}/taladrod/mitsubishi`,
      isFontSmall: true,
    },
    {
      title: 'BMW',
      key: 'BMW',
      icon: getStaticCDN('/my/img/menu-icons/bmw.png'),
      url: `${ENV_URL.th}/taladrod/bmw`,
      isFontSmall: true,
    },
    {
      title: 'Hyundai',
      key: 'Hyundai',
      icon: getStaticCDN('/static/img/searchBrandIcon/hyundai-color-icon.svg'),
      url: `${ENV_URL.th}/taladrod/hyundai`,
      isFontSmall: true,
    },
  ],
};
const DOWNLOAD_N_REGION = [
  {
    titleTranslate: 'shared.sideNavigation.download',
    key: 'download',
    content: 'download',
  },
];

const SELECT_N_REGION = [
  {
    titleTranslate: 'shared.sideNavigation.visit',
    key: 'region',
    content: 'region',
  },
];

export const MORE_DROPDOWN_MENU = (lang: TLanguageKey) => [
  {
    titleTranslate: 'shared.topNavigation.lease',
    key: 'lease',
    icon: getStaticCDN('/assets/shared/icons/brand-new-car.svg'),
    url: `${ENV_URL.sg}/leap`,
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.cover',
    key: 'cover',
    icon: getStaticCDN('/static/img/icons/umbrella.svg'),
    url: `${process.env.NEXT_PUBLIC_APP_ORIGIN}/sg/en/insurance`,
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.finance.finance',
    key: 'finance',
    icon: getStaticCDN('/static/img/icons/finance.svg'),
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.finance.usedCar',
        key: 'usedCar',
        url: `${ENV_URL.sg}/used-car-loan`,
      },
      // {
      //   titleTranslate: 'shared.topNavigation.moreDropdown.finance.renewal',
      //   key: 'renewal',
      //   url: `${ENV_URL.sg}/coe-renewal-loan`,
      // },
    ],
  },
  // {
  //   titleTranslate: 'shared.topNavigation.moreDropdown.carroAnywhere',
  //   key: 'carroAnywhere',
  //   icon: getStaticCDN('/static/img/icons/location-mark.svg'),
  //   url: `${ENV_URL.sg}/anywhere`,
  // },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.carroCare',
    key: 'carro-care',
    icon: getStaticCDN('/static/img/icons/workshop.svg'),
    url: URL_CONFIG({ region: 'sg', lang, path: 'carro-care' }).formatted,
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.guide.guide',
    key: 'guide',
    icon: getStaticCDN('/static/img/icons/guide.svg'),
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.guide.howItWorks',
        key: 'howItWorks',
        url: `${ENV_URL.sg}/faq`,
      },
      // {
      //   titleTranslate: 'shared.topNavigation.moreDropdown.guide.ask',
      //   key: 'ask',
      //   url: `https://ask.carro.sg/`,
      // },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.guide.blog',
        key: 'blog',
        url: `${ENV_URL.sg}/blog`,
      },
    ],
  },

  {
    titleTranslate: 'shared.topNavigation.moreDropdown.about.aboutCarro',
    key: 'aboutCarro',
    icon: getStaticCDN('/static/img/icons/office-icon.svg'),
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.about',
        key: 'About Us',
        url: `${ENV_URL.sg}/about`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.careers',
        key: 'Careers',
        url: `https://careers.carro.sg/jobs/Careers`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.contactUs',
        key: 'Contact Us',
        url: URL_CONFIG({ region: 'sg', lang, path: 'contact' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.locateUs',
        key: 'Locate Us',
        url: URL_CONFIG({ region: 'sg', lang, path: 'locate' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.hack',
        key: 'hack',
        url: `${ENV_URL.sg}/hackathon`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.newRoom',
        key: 'newRoom',
        url: `${ENV_URL.sg}/blog/category/carro-news/`,
      },
    ],
  },
];
export const MY_MORE_DROPDOWN_MENU = (lang: TLanguageKey) => [
  {
    titleTranslate: 'shared.topNavigation.certified',
    key: 'certified',
    url: URL_CONFIG({ region: 'my', lang, path: 'carro-certified' }).formatted,
    icon: getStaticCDN('/assets/shared/icons/award.svg'),
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.insure.insure',
    key: 'insure',
    icon: getStaticCDN('/static/img/icons/umbrella.svg'),

    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.insure.carInsure',
        key: 'carInsurance',
        url: `${NEXT_PUBLIC_WEB_CR}/my/en/insurance/comparison/AUTO`,
      },
    ],
  },
  // {
  //   titleTranslate: 'shared.topNavigation.moreDropdown.maintain',
  //   key: 'maintain',
  //   icon: getStaticCDN('/static/img/icons/workshop.svg'),
  //   url: `${ENV_URL.my}/rb/maintain`,
  // },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.dealership.dealership',
    key: 'dealership',
    icon: locationIcon,

    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.dealership.program',
        key: 'program',
        url: `${NEXT_PUBLIC_WEB_CR}/my/rb/dealership`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.dealership.finance',
        key: 'finance',
        url: `${NEXT_PUBLIC_WEB_CR}/my/rb/finance`,
      },
    ],
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.about.aboutCarro',
    key: 'aboutMytukar',
    icon: getStaticCDN('/static/img/icons/office-icon.svg'),
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.about',
        key: 'About Us',
        url: `${NEXT_PUBLIC_WEB_CR}/my/rb/about-us`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.blog',
        key: 'blog',
        url: `${NEXT_PUBLIC_WEB_CR}/my/blog`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.careers',
        key: 'Careers',
        url: `${NEXT_PUBLIC_WEB_CR}/my/rb/careers`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.contactUs',
        key: 'Contact Us',
        url: URL_CONFIG({ region: 'my', lang, path: 'contact' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.locateUs',
        key: 'Locate Us',
        url: URL_CONFIG({ region: 'my', lang, path: 'locate' }).formatted,
      },
      // {
      //   titleTranslate: 'shared.topNavigation.moreDropdown.about.carrocares',
      //   key: 'mytukarcares',
      //   url: `${ENV_URL.my}/rb/mytukarcares`,
      // },
    ],
  },
];
export const ID_MORE_DROPDOWN_MENU = (lang: TLanguageKey) => [
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.blog',
    key: 'blog',
    icon: blogIcon,
    url: `${ENV_URL.id}/blog`,
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.about.aboutCarro',
    key: 'about',
    icon: aboutIcon,
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.contactUs',
        key: 'contact',
        url: URL_CONFIG({ region: 'id', lang, path: 'contact' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.locateUs',
        key: 'Locate Us',
        url: URL_CONFIG({ region: 'id', lang, path: 'locate' }).formatted,
      },
    ],
  },
];
export const TH_MORE_DROPDOWN_MENU = (lang: TLanguageKey) => [
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.aboutCarro.aboutCarro',
    key: 'aboutCarro',
    icon: getStaticCDN('/static/img/icons/office-icon.svg'),
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.aboutCarro.aboutUs',
        key: 'aboutUs',
        url: `${ENV_URL.th}/about-us`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.aboutCarro.contactUs',
        key: 'contact',
        url: URL_CONFIG({ region: 'th', lang, path: 'contact' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.aboutCarro.locateUs',
        key: 'Locate Us',
        url: URL_CONFIG({ region: 'th', lang, path: 'locate' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.aboutCarro.workWith',
        key: 'workWith',
        url: `${ENV_URL.th}/job`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.aboutCarro.terms',
        key: 'terms',
        url: URL_CONFIG({ region: 'th', lang, path: 'terms' }).formatted,
      },
    ],
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.help.help',
    key: 'help',
    icon: questionIcon,
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.help.carLoanCalculator',
        key: 'carLoanCalculator',
        url: `${ENV_URL.th}/loan-calculator`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.help.download',
        key: 'download',
        url: `${ENV_URL.th}/download`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.help.FAQ',
        key: 'FAQ',
        url: `${ENV_URL.th}/faq`,
      },
    ],
  },
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.promotions',
    key: 'promotions',
    icon: percentIcon,
    url: `${ENV_URL.th}/privilege`,
  },
];

export const JP_MORE_DROPDOWN_MENU = (lang: TLanguageKey) => [
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.about.aboutCarro',
    key: 'about',
    icon: getStaticCDN('/static/img/icons/office-icon.svg'),
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.aboutUs',
        key: 'About Us',
        url: URL_CONFIG({ region: 'jp', lang, path: 'about' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.careers',
        key: 'Careers',
        url: URL_CONFIG({ region: 'jp', lang }).careers,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.contactUs',
        key: 'Contact Us',
        url: URL_CONFIG({ region: 'jp', lang, path: 'contact' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.locateUs',
        key: 'Locate Us',
        url: URL_CONFIG({ region: 'jp', lang, path: 'locate' }).formatted,
      },
    ],
  },
];
export const HK_MORE_DROPDOWN_MENU = (lang: TLanguageKey) => [
  {
    titleTranslate: 'shared.topNavigation.moreDropdown.about.aboutCarro',
    key: 'about',
    icon: getStaticCDN('/static/img/icons/office-icon.svg'),
    children: [
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.aboutUs',
        key: 'About Us',
        url: URL_CONFIG({ region: 'hk', lang, path: 'about' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.blog',
        key: 'blog',
        url: `${NEXT_PUBLIC_WEB_CR}/hk/blog`,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.contactUs',
        key: 'Contact Us',
        url: URL_CONFIG({ region: 'hk', lang, path: 'contact' }).formatted,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.about.locateUs',
        key: 'Locate Us',
        url: URL_CONFIG({ region: 'hk', lang, path: 'locate' }).formatted,
      },
    ],
  },
];

export const TOP_NAV_ACCOUNT = [
  {
    titleTranslate: 'shared.topNavigation.account.login',
    key: 'login',
    textWhite: true,
    hasAccountLogo: true,
  },
];

const MY_TOP_NAV_ACCOUNT = [
  {
    titleTranslate: 'shared.topNavigation.account.dealer',
    key: 'dealer',
    textWhite: true,
    url: `${NEXT_PUBLIC_DEALER_PORTAL_URL_MY}/login`,
  },
  {
    titleTranslate: 'shared.topNavigation.account.customer',
    key: 'customer',
    textWhite: true,
    showLoginModal: true,
  },
  {
    titleTranslate: 'shared.topNavigation.account.seller',
    key: 'seller',
    textWhite: true,
    showLoginModal: true,
    redirectTo: `${NEXT_PUBLIC_WEB_CR}/my/en/seller/home`,
  },
];

// const getCarMenuByRegionId = (region: string) => {
//   let carIds: any = [];
//   switch (region) {
//     case 'sg':
//       carIds = ['Toyota', 'Honda', 'Mercedes-Benz', 'Mazda'];
//       return carIds
//     case 'my':
//     default:
//   }
// };

export const SELL_MENU = (region: TRegionKey, lang: TLanguageKey): MenuItem => ({
  titleTranslate: 'shared.topNavigation.sell',
  key: 'sell',
  url: URL_CONFIG({ region, lang }).sell,
  pathName: 'sell',
  activeLink: '/sell',
});

export const BUY_MENU = ({ region, lang, subMenus, type }: any): MenuItem => {
  const buyObj = {
    titleTranslate: 'shared.topNavigation.buy',
    key: 'buy',
    url: URL_CONFIG({ region, lang }).buy,
    pathName: 'buy',
    ...(subMenus ? { subMenus } : {}),
    ...(type ? { type } : {}),
    activeLink: '/',
    customDropdownSubMenu: BuyDropDownMenu,
  };
  return buyObj;
};

const desktopHeaderConfigs: any = (region: TRegionKey, lang: TLanguageKey) => ({
  sg: {
    brandLogo: {
      src: staticImgs.carroLogo,
    },
    phone: '6714 6652',
    rightMenu: [
      // The item with dropdown type on menu will need the structure like below
      // { ...BUY_MENU({ region, lang, subMenus: BUY_DROPDOWN_MENU.SG, type: 'dropdown' }) },
      { ...BUY_MENU({ region, lang }) },
      { ...SELL_MENU(region, lang) },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.brandNewCars',
        key: 'buyNew',
        url: URL_CONFIG({ region: 'sg', lang }).buyNew,
        activeLink: '/buy-new',
      },
      {
        titleTranslate: 'shared.topNavigation.certified',
        key: 'certified',
        url: URL_CONFIG({ region: 'sg', lang, path: 'carro-certified' }).formatted,
        activeLink: '/carro-certified',
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.more',
        key: 'more',
        subMenus: [...MORE_DROPDOWN_MENU(lang), ...DOWNLOAD_N_REGION, ...SELECT_N_REGION],
        type: 'dropdown',
      },
      {
        titleTranslate: 'shared.topNavigation.account.account',
        icon: staticImgs.userIcon,
        key: 'account',
        subMenus: TOP_NAV_ACCOUNT,
        type: 'dropdown',
      },
    ],
  },
  my: {
    brandLogo: {
      src: staticImgs.carroLogo,
    },
    phone: '+60162996736',
    rightMenu: [
      { ...BUY_MENU({ region, lang }) },
      { ...SELL_MENU(region, lang) },
      {
        titleTranslate: 'shared.topNavigation.sellB5',
        key: 'sellB5',
        url: URL_CONFIG({ region: 'my', lang, path: 'b5' }).formatted,
        activeLink: '/b5',
      },
      {
        titleTranslate: 'shared.topNavigation.zeekr',
        key: 'zeekr',
        url: URL_CONFIG({ region: 'my', lang, path: 'zeekr' }).formatted,
        activeLink: '/zeekr',
      },
      {
        titleTranslate: 'shared.topNavigation.workshop',
        key: 'workshop',
        url: URL_CONFIG({ region: 'my', lang, path: 'workshop' }).formatted,
        activeLink: '/refurb',
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.more',
        key: 'more',
        subMenus: [...MY_MORE_DROPDOWN_MENU(lang), ...SELECT_N_REGION],
        type: 'dropdown',
      },
      {
        titleTranslate: 'shared.topNavigation.account.account',
        icon: staticImgs.userIcon,
        key: 'account',
        subMenus: MY_TOP_NAV_ACCOUNT,
        type: 'dropdown',
      },
    ],
  },
  id: {
    brandLogo: {
      src: staticImgs.carroLogo,
    },
    phone: '021-50996789',
    rightMenu: [
      { ...BUY_MENU({ region, lang }) },
      { ...SELL_MENU(region, lang) },
      {
        titleTranslate: 'shared.topNavigation.certified',
        key: 'certified',
        url: URL_CONFIG({ region: 'id', lang, path: 'carro-certified' }).formatted,
        activeLink: '/carro-certified',
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.more',
        key: 'more',
        subMenus: [...ID_MORE_DROPDOWN_MENU(lang), ...SELECT_N_REGION],
        type: 'dropdown',
      },
      {
        titleTranslate: 'shared.topNavigation.account.account',
        icon: staticImgs.userIcon,
        key: 'account',
        subMenus: TOP_NAV_ACCOUNT,
        type: 'dropdown',
      },
    ],
  },
  th: {
    brandLogo: {
      src: staticImgs.carroLogo,
    },
    phone: '02-460-9380',
    rightMenu: [
      { ...BUY_MENU({ region, lang }) },
      { ...SELL_MENU(region, lang) },
      {
        titleTranslate: 'shared.topNavigation.certified',
        key: 'certified',
        url: URL_CONFIG({ region: 'th', lang, path: 'carro-certified' }).formatted,
        activeLink: '/carro-certified',
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.more',
        key: 'more',
        subMenus: [...TH_MORE_DROPDOWN_MENU(lang), ...SELECT_N_REGION],
        type: 'dropdown',
      },
      {
        titleTranslate: 'shared.topNavigation.account.account',
        icon: staticImgs.userIcon,
        key: 'account',
        subMenus: TOP_NAV_ACCOUNT,
        type: 'dropdown',
      },
    ],
  },
  jp: {
    brandLogo: {
      src: staticImgs.carroLogo,
    },
    phone: '048-951-4002',
    rightMenu: [
      { ...BUY_MENU({ region, lang }) },
      { ...SELL_MENU(region, lang) },
      {
        titleTranslate: 'shared.topNavigation.certified',
        key: 'certified',
        url: URL_CONFIG({ region: 'jp', lang, path: 'carro-certified' }).formatted,
        activeLink: '/carro-certified',
      },
      {
        titleTranslate: 'shared.topNavigation.leasing',
        key: 'leasing',
        url: `https://carrojapan.com`,
        isExternal: true,
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.more',
        key: 'more',
        subMenus: [...JP_MORE_DROPDOWN_MENU(lang), ...SELECT_N_REGION],
        type: 'dropdown',
      },
      {
        titleTranslate: 'shared.topNavigation.account.account',
        icon: staticImgs.userIcon,
        key: 'account',
        subMenus: TOP_NAV_ACCOUNT,
        type: 'dropdown',
      },
    ],
  },
  hk: {
    brandLogo: {
      src: staticImgs.carroLogo,
    },
    phone: '852-3001-6749',
    rightMenu: [
      { ...BUY_MENU({ region, lang }) },
      { ...SELL_MENU(region, lang) },
      {
        titleTranslate: 'shared.topNavigation.carroCare',
        key: 'carroCare',
        url: URL_CONFIG({ region: 'hk', lang, path: 'carro-care' }).formatted,
        activeLink: '/refurb',
      },
      {
        titleTranslate: 'shared.topNavigation.certified',
        key: 'certified',
        url: URL_CONFIG({ region: 'hk', lang, path: 'carro-certified' }).formatted,
        activeLink: '/carro-certified',
      },
      {
        titleTranslate: 'shared.topNavigation.finance',
        key: 'finance',
        url: URL_CONFIG({ region: 'hk', lang }).finance,
        activeLink: '/finance',
      },
      {
        titleTranslate: 'shared.topNavigation.moreDropdown.more',
        key: 'more',
        subMenus: [...HK_MORE_DROPDOWN_MENU(lang), ...SELECT_N_REGION],
        type: 'dropdown',
      },
      {
        titleTranslate: 'shared.topNavigation.account.account',
        icon: staticImgs.userIcon,
        key: 'account',
        subMenus: TOP_NAV_ACCOUNT,
        type: 'dropdown',
      },
    ],
  },
});
export interface IBrand {
  id: string;
  label: string;
  slug: string;
}

// All available brands
export const ALL_BRANDS = {
  'alfa-romeo': { id: 'alfa-romeo', label: 'Alfa Romeo', slug: 'alfa-romeo' },
  'aston-martin': { id: 'aston-martin', label: 'Aston Martin', slug: 'aston-martin' },
  audi: { id: 'audi', label: 'Audi', slug: 'audi' },
  bentley: { id: 'bentley', label: 'Bentley', slug: 'bentley' },
  bmw: { id: 'bmw', label: 'BMW', slug: 'bmw' },
  byd: { id: 'byd', label: 'BYD', slug: 'byd' },
  cadillac: { id: 'cadillac', label: 'Cadillac', slug: 'cadillac' },
  chery: { id: 'chery', label: 'Chery', slug: 'chery' },
  chevrolet: { id: 'chevrolet', label: 'Chevrolet', slug: 'chevrolet' },
  chrysler: { id: 'chrysler', label: 'Chrysler', slug: 'chrysler' },
  citroen: { id: 'citroen', label: 'Citroen', slug: 'citroen' },
  daihatsu: { id: 'daihatsu', label: 'Daihatsu', slug: 'daihatsu' },
  dodge: { id: 'dodge', label: 'Dodge', slug: 'dodge' },
  ferrari: { id: 'ferrari', label: 'Ferrari', slug: 'ferrari' },
  fiat: { id: 'fiat', label: 'Fiat', slug: 'fiat' },
  ford: { id: 'ford', label: 'Ford', slug: 'ford' },
  geely: { id: 'geely', label: 'Geely', slug: 'geely' },
  gwm: { id: 'gwm', label: 'GWM', slug: 'gwm' },
  haval: { id: 'haval', label: 'Haval', slug: 'haval' },
  honda: { id: 'honda', label: 'Honda', slug: 'honda' },
  hyundai: { id: 'hyundai', label: 'Hyundai', slug: 'hyundai' },
  infiniti: { id: 'infiniti', label: 'Infiniti', slug: 'infiniti' },
  isuzu: { id: 'isuzu', label: 'Isuzu', slug: 'isuzu' },
  jaguar: { id: 'jaguar', label: 'Jaguar', slug: 'jaguar' },
  jeep: { id: 'jeep', label: 'Jeep', slug: 'jeep' },
  kia: { id: 'kia', label: 'Kia', slug: 'kia' },
  lamborghini: { id: 'lamborghini', label: 'Lamborghini', slug: 'lamborghini' },
  'land-rover': { id: 'land-rover', label: 'Land Rover', slug: 'land-rover' },
  lexus: { id: 'lexus', label: 'Lexus', slug: 'lexus' },
  maserati: { id: 'maserati', label: 'Maserati', slug: 'maserati' },
  mazda: { id: 'mazda', label: 'Mazda', slug: 'mazda' },
  'mercedes-benz': { id: 'mercedes-benz', label: 'Mercedes-Benz', slug: 'mercedes-benz' },
  mg: { id: 'mg', label: 'MG', slug: 'mg' },
  'mg-rover': { id: 'mg-rover', label: 'MG Rover', slug: 'mg-rover' },
  mini: { id: 'mini', label: 'Mini', slug: 'mini' },
  mitsubishi: { id: 'mitsubishi', label: 'Mitsubishi', slug: 'mitsubishi' },
  neta: { id: 'neta', label: 'Neta', slug: 'neta' },
  nissan: { id: 'nissan', label: 'Nissan', slug: 'nissan' },
  opel: { id: 'opel', label: 'Opel', slug: 'opel' },
  ora: { id: 'ora', label: 'ORA', slug: 'ora' },
  perodua: { id: 'perodua', label: 'Perodua', slug: 'perodua' },
  peugeot: { id: 'peugeot', label: 'Peugeot', slug: 'peugeot' },
  polestar: { id: 'polestar', label: 'Polestar', slug: 'polestar' },
  porsche: { id: 'porsche', label: 'Porsche', slug: 'porsche' },
  proton: { id: 'proton', label: 'Proton', slug: 'proton' },
  renault: { id: 'renault', label: 'Renault', slug: 'renault' },
  'rolls-royce': { id: 'rolls-royce', label: 'Rolls Royce', slug: 'rolls-royce' },
  skoda: { id: 'skoda', label: 'Skoda', slug: 'skoda' },
  subaru: { id: 'subaru', label: 'Subaru', slug: 'subaru' },
  suzuki: { id: 'suzuki', label: 'Suzuki', slug: 'suzuki' },
  tesla: { id: 'tesla', label: 'Tesla', slug: 'tesla' },
  toyota: { id: 'toyota', label: 'Toyota', slug: 'toyota' },
  volkswagen: { id: 'volkswagen', label: 'Volkswagen', slug: 'volkswagen' },
  volvo: { id: 'volvo', label: 'Volvo', slug: 'volvo' },
  wuling: { id: 'wuling', label: 'Wuling', slug: 'wuling' },
};

const buildBrandUrl = (region: TRegionKey, lang: TLanguageKey, brandSlug: string): string => {
  return `${NEXT_PUBLIC_WEB_CR}/${region}/${lang}/buy/${brandSlug}`;
};

// Region-specific brand configurations
type DeviceBrands = { popular: IBrand[][]; moreBrands: IBrand[][] };
const REGION_BRANDS: Record<TRegionKey, { mobile: DeviceBrands; desktop: DeviceBrands }> = {
  sg: {
    mobile: {
      popular: [
        [ALL_BRANDS.honda, ALL_BRANDS.toyota, ALL_BRANDS.hyundai, ALL_BRANDS.audi, ALL_BRANDS.nissan],
        [ALL_BRANDS.bmw, ALL_BRANDS['mercedes-benz'], ALL_BRANDS.mazda, ALL_BRANDS.kia],
      ],
      moreBrands: [
        [
          ALL_BRANDS.byd,
          ALL_BRANDS.citroen,
          ALL_BRANDS.ferrari,
          ALL_BRANDS.ford,
          ALL_BRANDS.infiniti,
          ALL_BRANDS.jaguar,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.lexus,
          ALL_BRANDS.maserati,
          ALL_BRANDS['mg-rover'],
          ALL_BRANDS.mini,
          ALL_BRANDS.mitsubishi,
        ],
        [
          ALL_BRANDS.opel,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.polestar,
          ALL_BRANDS.porsche,
          ALL_BRANDS.renault,
          ALL_BRANDS['rolls-royce'],
          ALL_BRANDS.skoda,
          ALL_BRANDS.subaru,
          ALL_BRANDS.suzuki,
          ALL_BRANDS.tesla,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.volvo,
        ],
      ],
    },
    desktop: {
      popular: [
        [ALL_BRANDS.honda, ALL_BRANDS.toyota, ALL_BRANDS.audi],
        [ALL_BRANDS.bmw, ALL_BRANDS.hyundai, ALL_BRANDS.kia],
        [ALL_BRANDS['mercedes-benz'], ALL_BRANDS.mazda, ALL_BRANDS.nissan],
      ],
      moreBrands: [
        [
          ALL_BRANDS.byd,
          ALL_BRANDS.citroen,
          ALL_BRANDS.ferrari,
          ALL_BRANDS.ford,
          ALL_BRANDS.infiniti,
          ALL_BRANDS.jaguar,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.lexus,
        ],
        [
          ALL_BRANDS.maserati,
          ALL_BRANDS['mg-rover'],
          ALL_BRANDS.mini,
          ALL_BRANDS.mitsubishi,
          ALL_BRANDS.opel,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.polestar,
          ALL_BRANDS.porsche,
        ],
        [
          ALL_BRANDS.renault,
          ALL_BRANDS['rolls-royce'],
          ALL_BRANDS.skoda,
          ALL_BRANDS.subaru,
          ALL_BRANDS.suzuki,
          ALL_BRANDS.tesla,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.volvo,
        ],
      ],
    },
  },
  my: {
    mobile: {
      popular: [
        [ALL_BRANDS.perodua, ALL_BRANDS.proton, ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS.nissan],
        [ALL_BRANDS.bmw, ALL_BRANDS['mercedes-benz'], ALL_BRANDS.mazda, ALL_BRANDS.hyundai],
      ],
      moreBrands: [
        [
          ALL_BRANDS.audi,
          ALL_BRANDS.byd,
          ALL_BRANDS.chery,
          ALL_BRANDS.ford,
          ALL_BRANDS.isuzu,
          ALL_BRANDS.kia,
          ALL_BRANDS.lexus,
          ALL_BRANDS.mitsubishi,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.subaru,
          ALL_BRANDS.suzuki,
          ALL_BRANDS.volkswagen,
        ],
        [
          ALL_BRANDS.volvo,
          ALL_BRANDS.porsche,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
          ALL_BRANDS.mini,
          ALL_BRANDS.tesla,
          ALL_BRANDS.haval,
          ALL_BRANDS.geely,
          ALL_BRANDS.mg,
          ALL_BRANDS.renault,
          ALL_BRANDS.skoda,
          ALL_BRANDS.citroen,
        ],
      ],
    },
    desktop: {
      popular: [
        [ALL_BRANDS.perodua, ALL_BRANDS.proton, ALL_BRANDS.toyota],
        [ALL_BRANDS.honda, ALL_BRANDS.nissan, ALL_BRANDS.bmw],
        [ALL_BRANDS['mercedes-benz'], ALL_BRANDS.mazda, ALL_BRANDS.hyundai],
      ],
      moreBrands: [
        [
          ALL_BRANDS.audi,
          ALL_BRANDS.byd,
          ALL_BRANDS.chery,
          ALL_BRANDS.ford,
          ALL_BRANDS.isuzu,
          ALL_BRANDS.kia,
          ALL_BRANDS.lexus,
          ALL_BRANDS.mitsubishi,
        ],
        [
          ALL_BRANDS.peugeot,
          ALL_BRANDS.subaru,
          ALL_BRANDS.suzuki,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.volvo,
          ALL_BRANDS.porsche,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
        ],
        [
          ALL_BRANDS.mini,
          ALL_BRANDS.tesla,
          ALL_BRANDS.haval,
          ALL_BRANDS.geely,
          ALL_BRANDS.mg,
          ALL_BRANDS.renault,
          ALL_BRANDS.skoda,
          ALL_BRANDS.citroen,
        ],
      ],
    },
  },
  id: {
    mobile: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS.mitsubishi, ALL_BRANDS.daihatsu, ALL_BRANDS.suzuki],
        [ALL_BRANDS.nissan, ALL_BRANDS.mazda, ALL_BRANDS.hyundai, ALL_BRANDS.wuling],
      ],
      moreBrands: [
        [
          ALL_BRANDS.bmw,
          ALL_BRANDS['mercedes-benz'],
          ALL_BRANDS.audi,
          ALL_BRANDS.lexus,
          ALL_BRANDS.isuzu,
          ALL_BRANDS.kia,
          ALL_BRANDS.ford,
          ALL_BRANDS.chevrolet,
          ALL_BRANDS.jeep,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.mg,
        ],
        [
          ALL_BRANDS.chery,
          ALL_BRANDS.byd,
          ALL_BRANDS.haval,
          ALL_BRANDS.geely,
          ALL_BRANDS.mini,
          ALL_BRANDS.porsche,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
          ALL_BRANDS.volvo,
          ALL_BRANDS.subaru,
          ALL_BRANDS.renault,
          ALL_BRANDS.tesla,
        ],
      ],
    },
    desktop: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS.mitsubishi],
        [ALL_BRANDS.daihatsu, ALL_BRANDS.suzuki, ALL_BRANDS.nissan],
        [ALL_BRANDS.mazda, ALL_BRANDS.hyundai, ALL_BRANDS.wuling],
      ],
      moreBrands: [
        [
          ALL_BRANDS.bmw,
          ALL_BRANDS['mercedes-benz'],
          ALL_BRANDS.audi,
          ALL_BRANDS.lexus,
          ALL_BRANDS.isuzu,
          ALL_BRANDS.kia,
          ALL_BRANDS.ford,
          ALL_BRANDS.chevrolet,
        ],
        [
          ALL_BRANDS.jeep,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.mg,
          ALL_BRANDS.chery,
          ALL_BRANDS.byd,
          ALL_BRANDS.haval,
          ALL_BRANDS.geely,
        ],
        [
          ALL_BRANDS.mini,
          ALL_BRANDS.porsche,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
          ALL_BRANDS.volvo,
          ALL_BRANDS.subaru,
          ALL_BRANDS.renault,
          ALL_BRANDS.tesla,
        ],
      ],
    },
  },
  th: {
    mobile: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS.isuzu, ALL_BRANDS.mitsubishi, ALL_BRANDS.mazda],
        [ALL_BRANDS.nissan, ALL_BRANDS.ford, ALL_BRANDS.mg, ALL_BRANDS.suzuki],
      ],
      moreBrands: [
        [
          ALL_BRANDS.bmw,
          ALL_BRANDS['mercedes-benz'],
          ALL_BRANDS.hyundai,
          ALL_BRANDS.kia,
          ALL_BRANDS.subaru,
          ALL_BRANDS.volvo,
          ALL_BRANDS.lexus,
          ALL_BRANDS.audi,
          ALL_BRANDS.porsche,
          ALL_BRANDS.mini,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.byd,
        ],
        [
          ALL_BRANDS.tesla,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
          ALL_BRANDS.chevrolet,
          ALL_BRANDS.jeep,
          ALL_BRANDS.haval,
          ALL_BRANDS.geely,
          ALL_BRANDS.chery,
          ALL_BRANDS.neta,
          ALL_BRANDS.ora,
          ALL_BRANDS.gwm,
        ],
      ],
    },
    desktop: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS.isuzu],
        [ALL_BRANDS.mitsubishi, ALL_BRANDS.mazda, ALL_BRANDS.nissan],
        [ALL_BRANDS.ford, ALL_BRANDS.mg, ALL_BRANDS.suzuki],
      ],
      moreBrands: [
        [
          ALL_BRANDS.bmw,
          ALL_BRANDS['mercedes-benz'],
          ALL_BRANDS.hyundai,
          ALL_BRANDS.kia,
          ALL_BRANDS.subaru,
          ALL_BRANDS.volvo,
          ALL_BRANDS.lexus,
          ALL_BRANDS.audi,
        ],
        [
          ALL_BRANDS.porsche,
          ALL_BRANDS.mini,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.byd,
          ALL_BRANDS.tesla,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
        ],
        [
          ALL_BRANDS.chevrolet,
          ALL_BRANDS.jeep,
          ALL_BRANDS.haval,
          ALL_BRANDS.geely,
          ALL_BRANDS.chery,
          ALL_BRANDS.neta,
          ALL_BRANDS.ora,
          ALL_BRANDS.gwm,
        ],
      ],
    },
  },
  jp: {
    mobile: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS.nissan, ALL_BRANDS.mazda, ALL_BRANDS.subaru],
        [ALL_BRANDS.suzuki, ALL_BRANDS.daihatsu, ALL_BRANDS.mitsubishi, ALL_BRANDS.lexus],
      ],
      moreBrands: [
        [
          ALL_BRANDS.bmw,
          ALL_BRANDS['mercedes-benz'],
          ALL_BRANDS.audi,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.volvo,
          ALL_BRANDS.porsche,
          ALL_BRANDS.mini,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
          ALL_BRANDS['alfa-romeo'],
          ALL_BRANDS.fiat,
          ALL_BRANDS.jeep,
        ],
        [
          ALL_BRANDS.tesla,
          ALL_BRANDS.byd,
          ALL_BRANDS.hyundai,
          ALL_BRANDS.kia,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.renault,
          ALL_BRANDS.citroen,
          ALL_BRANDS.ford,
          ALL_BRANDS.chevrolet,
          ALL_BRANDS.chrysler,
          ALL_BRANDS.dodge,
          ALL_BRANDS.cadillac,
        ],
      ],
    },
    desktop: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS.nissan],
        [ALL_BRANDS.mazda, ALL_BRANDS.subaru, ALL_BRANDS.suzuki],
        [ALL_BRANDS.daihatsu, ALL_BRANDS.mitsubishi, ALL_BRANDS.lexus],
      ],
      moreBrands: [
        [
          ALL_BRANDS.bmw,
          ALL_BRANDS['mercedes-benz'],
          ALL_BRANDS.audi,
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.volvo,
          ALL_BRANDS.porsche,
          ALL_BRANDS.mini,
          ALL_BRANDS['land-rover'],
        ],
        [
          ALL_BRANDS.jaguar,
          ALL_BRANDS['alfa-romeo'],
          ALL_BRANDS.fiat,
          ALL_BRANDS.jeep,
          ALL_BRANDS.tesla,
          ALL_BRANDS.byd,
          ALL_BRANDS.hyundai,
          ALL_BRANDS.kia,
        ],
        [
          ALL_BRANDS.peugeot,
          ALL_BRANDS.renault,
          ALL_BRANDS.citroen,
          ALL_BRANDS.ford,
          ALL_BRANDS.chevrolet,
          ALL_BRANDS.chrysler,
          ALL_BRANDS.dodge,
          ALL_BRANDS.cadillac,
        ],
      ],
    },
  },
  hk: {
    mobile: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS['mercedes-benz'], ALL_BRANDS.bmw, ALL_BRANDS.audi],
        [ALL_BRANDS.lexus, ALL_BRANDS.nissan, ALL_BRANDS.mazda, ALL_BRANDS.hyundai],
      ],
      moreBrands: [
        [
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.volvo,
          ALL_BRANDS.porsche,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
          ALL_BRANDS.mini,
          ALL_BRANDS.kia,
          ALL_BRANDS.subaru,
          ALL_BRANDS.suzuki,
          ALL_BRANDS.mitsubishi,
          ALL_BRANDS.ford,
          ALL_BRANDS.tesla,
        ],
        [
          ALL_BRANDS.byd,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.renault,
          ALL_BRANDS.citroen,
          ALL_BRANDS['alfa-romeo'],
          ALL_BRANDS.fiat,
          ALL_BRANDS.maserati,
          ALL_BRANDS.ferrari,
          ALL_BRANDS.lamborghini,
          ALL_BRANDS.bentley,
          ALL_BRANDS['rolls-royce'],
          ALL_BRANDS['aston-martin'],
        ],
      ],
    },
    desktop: {
      popular: [
        [ALL_BRANDS.toyota, ALL_BRANDS.honda, ALL_BRANDS['mercedes-benz']],
        [ALL_BRANDS.bmw, ALL_BRANDS.audi, ALL_BRANDS.lexus],
        [ALL_BRANDS.nissan, ALL_BRANDS.mazda, ALL_BRANDS.hyundai],
      ],
      moreBrands: [
        [
          ALL_BRANDS.volkswagen,
          ALL_BRANDS.volvo,
          ALL_BRANDS.porsche,
          ALL_BRANDS['land-rover'],
          ALL_BRANDS.jaguar,
          ALL_BRANDS.mini,
          ALL_BRANDS.kia,
          ALL_BRANDS.subaru,
        ],
        [
          ALL_BRANDS.suzuki,
          ALL_BRANDS.mitsubishi,
          ALL_BRANDS.ford,
          ALL_BRANDS.tesla,
          ALL_BRANDS.byd,
          ALL_BRANDS.peugeot,
          ALL_BRANDS.renault,
          ALL_BRANDS.citroen,
        ],
        [
          ALL_BRANDS['alfa-romeo'],
          ALL_BRANDS.fiat,
          ALL_BRANDS.maserati,
          ALL_BRANDS.ferrari,
          ALL_BRANDS.lamborghini,
          ALL_BRANDS.bentley,
          ALL_BRANDS['rolls-royce'],
          ALL_BRANDS['aston-martin'],
        ],
      ],
    },
  },
};

export const getBuyDropdownCategories = (
  region: TRegionKey,
  lang: TLanguageKey,
  device: 'mobile' | 'desktop' = 'mobile',
) => {
  const regionConfig = REGION_BRANDS[region] || REGION_BRANDS.sg;
  const regionBrands = regionConfig[device];

  return {
    popular: {
      label: 'POPULAR',
      columns: regionBrands.popular.map((column) =>
        column.map((brand) => ({
          ...brand,
          url: buildBrandUrl(region, lang, brand.slug),
        })),
      ),
    },
    moreBrands: {
      label: 'MORE BRANDS',
      columns: regionBrands.moreBrands.map((column) =>
        column.map((brand) => ({
          ...brand,
          url: buildBrandUrl(region, lang, brand.slug),
        })),
      ),
    },
  };
};

export default desktopHeaderConfigs;
